import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Y42FeatureTypeToRoute } from '@y42/feature/routing';
import { Y42FeatureType } from '@y42/json-schema';

@Injectable()
export class Y42TitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  private readonly featureRoutes = Object.values(Y42FeatureType).map(
    (featureType) => Y42FeatureTypeToRoute[featureType as Y42FeatureType],
  );

  override updateTitle(state: RouterStateSnapshot) {
    // do not do anything if we are on a feature-route
    // which is where the FeatureTitleService acts on the title
    if (this.featureRoutes.some((route) => state.url.includes(route))) {
      return;
    }

    const title = this.buildTitle(state);
    if (title) {
      this.title.setTitle(`${title} | Y42`);
    } else {
      this.title.setTitle(`Y42`);
    }
  }
}
